/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.ts to modify the generation of this file.




import * as ArticlePageRendering from 'src/components/renderings/ArticlePageRendering';
import * as TopMessageRendering from 'src/components/renderings/TopMessageRendering';
import * as CarouselModel from 'src/components/renderings/Carousel/CarouselModel';
import * as CarouselRendering from 'src/components/renderings/Carousel/CarouselRendering';
import * as FooterNavigationRendering from 'src/components/renderings/footerRenderings/FooterNavigationRendering';
import * as CmsRewardsFormRendering from 'src/components/renderings/formsRenderings/CmsRewardsFormRendering';
import * as CmsRewardsModalRendering from 'src/components/renderings/formsRenderings/CmsRewardsModalRendering';
import * as NewsletterFormRendering from 'src/components/renderings/formsRenderings/NewsletterFormRendering';
import * as HeaderRendering from 'src/components/renderings/headerRenderings/HeaderRendering';
import * as AccordionListRendering from 'src/components/renderings/pageRenderings/AccordionListRendering';
import * as AnimatedHeroRendering from 'src/components/renderings/pageRenderings/AnimatedHeroRendering';
import * as BannerRendering from 'src/components/renderings/pageRenderings/BannerRendering';
import * as BlogListRendering from 'src/components/renderings/pageRenderings/BlogListRendering';
import * as BodyBannerRendering from 'src/components/renderings/pageRenderings/BodyBannerRendering';
import * as BodyMessageRendering from 'src/components/renderings/pageRenderings/BodyMessageRendering';
import * as ButtonCMSRendering from 'src/components/renderings/pageRenderings/ButtonCMSRendering';
import * as CardListRendering from 'src/components/renderings/pageRenderings/CardListRendering';
import * as CardRendering from 'src/components/renderings/pageRenderings/CardRendering';
import * as GalleryRendering from 'src/components/renderings/pageRenderings/GalleryRendering';
import * as HeroRendering from 'src/components/renderings/pageRenderings/HeroRendering';
import * as HorizontalLineRendering from 'src/components/renderings/pageRenderings/HorizontalLineRendering';
import * as JumbotronListRendering from 'src/components/renderings/pageRenderings/JumbotronListRendering';
import * as JumbotronRendering from 'src/components/renderings/pageRenderings/JumbotronRendering';
import * as PodRendering from 'src/components/renderings/pageRenderings/PodRendering';
import * as RichTextRendering from 'src/components/renderings/pageRenderings/RichTextRendering';
import * as SectionBannerRendering from 'src/components/renderings/pageRenderings/SectionBannerRendering';
import * as SkipLinkRendering from 'src/components/renderings/pageRenderings/SkipLinkRendering';
import * as VideoRendering from 'src/components/renderings/pageRenderings/VideoRendering';
import * as AarpRendering from 'src/components/renderings/staticPagesRenderings/Aarp/AarpRendering';
import * as GoToLocationRendering from 'src/components/renderings/staticPagesRenderings/GoTo/GoToLocationRendering';
import * as GoToMenuRendering from 'src/components/renderings/staticPagesRenderings/GoTo/GoToMenuRendering';
import * as GoToOrderRendering from 'src/components/renderings/staticPagesRenderings/GoTo/GoToOrderRendering';
import * as InternationalRendering from 'src/components/renderings/staticPagesRenderings/International/InternationalRendering';
import * as GlutenFreeRendering from 'src/components/renderings/staticPagesRenderings/Nutrition/GlutenFreeRendering';
import * as KidsLiveWellRendering from 'src/components/renderings/staticPagesRenderings/Nutrition/KidsLiveWellRendering';
import * as SmartDiningRendering from 'src/components/renderings/staticPagesRenderings/Nutrition/SmartDiningRendering';
import * as SeatingDetailsRendering from 'src/components/renderings/staticPagesRenderings/Seating/SeatingDetailsRendering';
import * as SeatingRendering from 'src/components/renderings/staticPagesRenderings/Seating/SeatingRendering';
import * as SteakStoryRendering from 'src/components/renderings/staticPagesRenderings/SteakStory/SteakStoryRendering';
import * as TailgateRendering from 'src/components/renderings/staticPagesRenderings/Tailgate/TailgateRendering';
import * as ContainerRendering from 'src/components/renderings/structureRenderings/ContainerRendering';
import * as LateralBarRendering from 'src/components/renderings/structureRenderings/LateralBarRendering';
import * as OneColumnRendering from 'src/components/renderings/structureRenderings/OneColumnRendering';
import * as SideBarContainerRendering from 'src/components/renderings/structureRenderings/SideBarContainerRendering';
import * as ThreeColumnRendering from 'src/components/renderings/structureRenderings/ThreeColumnRendering';
import * as TwoColumnRendering from 'src/components/renderings/structureRenderings/TwoColumnRendering';
import * as VerticalSpaceRendering from 'src/components/renderings/structureRenderings/VerticalSpaceRendering';

const components = new Map();

components.set('ArticlePageRendering', ArticlePageRendering);
components.set('TopMessageRendering', TopMessageRendering);
components.set('CarouselModel', CarouselModel);
components.set('CarouselRendering', CarouselRendering);
components.set('FooterNavigationRendering', FooterNavigationRendering);
components.set('CmsRewardsFormRendering', CmsRewardsFormRendering);
components.set('CmsRewardsModalRendering', CmsRewardsModalRendering);
components.set('NewsletterFormRendering', NewsletterFormRendering);
components.set('HeaderRendering', HeaderRendering);
components.set('AccordionListRendering', AccordionListRendering);
components.set('AnimatedHeroRendering', AnimatedHeroRendering);
components.set('BannerRendering', BannerRendering);
components.set('BlogListRendering', BlogListRendering);
components.set('BodyBannerRendering', BodyBannerRendering);
components.set('BodyMessageRendering', BodyMessageRendering);
components.set('ButtonCMSRendering', ButtonCMSRendering);
components.set('CardListRendering', CardListRendering);
components.set('CardRendering', CardRendering);
components.set('GalleryRendering', GalleryRendering);
components.set('HeroRendering', HeroRendering);
components.set('HorizontalLineRendering', HorizontalLineRendering);
components.set('JumbotronListRendering', JumbotronListRendering);
components.set('JumbotronRendering', JumbotronRendering);
components.set('PodRendering', PodRendering);
components.set('RichTextRendering', RichTextRendering);
components.set('SectionBannerRendering', SectionBannerRendering);
components.set('SkipLinkRendering', SkipLinkRendering);
components.set('VideoRendering', VideoRendering);
components.set('AarpRendering', AarpRendering);
components.set('GoToLocationRendering', GoToLocationRendering);
components.set('GoToMenuRendering', GoToMenuRendering);
components.set('GoToOrderRendering', GoToOrderRendering);
components.set('InternationalRendering', InternationalRendering);
components.set('GlutenFreeRendering', GlutenFreeRendering);
components.set('KidsLiveWellRendering', KidsLiveWellRendering);
components.set('SmartDiningRendering', SmartDiningRendering);
components.set('SeatingDetailsRendering', SeatingDetailsRendering);
components.set('SeatingRendering', SeatingRendering);
components.set('SteakStoryRendering', SteakStoryRendering);
components.set('TailgateRendering', TailgateRendering);
components.set('ContainerRendering', ContainerRendering);
components.set('LateralBarRendering', LateralBarRendering);
components.set('OneColumnRendering', OneColumnRendering);
components.set('SideBarContainerRendering', SideBarContainerRendering);
components.set('ThreeColumnRendering', ThreeColumnRendering);
components.set('TwoColumnRendering', TwoColumnRendering);
components.set('VerticalSpaceRendering', VerticalSpaceRendering);

// Next.js 'dynamic' import and JavaScript 'dynamic' import are different.
// Next.js 'dynamic(...)' returns common 'React.ComponentType' while
// 'import('...')' returns 'Promise' that will resolve module.
// componentModule uses 'import(...)' because primary usage of it to get not only 'React Component' (default export) but all named exports.
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import#dynamic_imports
// componentFactory uses 'dynamic(...)' because primary usage of it to render 'React Component' (default export).
// See https://nextjs.org/docs/advanced-features/dynamic-import
// At the end you will have single preloaded script for each lazy loading module.

export function componentModule(componentName: string) {
  const component = components.get(componentName);

  // check that component is lazy loading module
  if (!component?.default && component?.module) {
    // return js dynamic import
    return component.module();
  }

  return component;
}
  
export function componentFactory(componentName: string) {
  const component = components.get(componentName);

  // check that component should be dynamically imported
  if (component?.element) {
    // return next.js dynamic import
    return component.element();
  }

  return component?.default || component;
}
